import React from 'react'
import '../Assets/Additionalcss/ActivatePage.css'
import axios from 'axios'
import { BASE_URL } from '../Config/Base'
import { useNavigate } from 'react-router-dom';

import {
   
  Navigate,
    useParams,
    } from "react-router-dom";

const AcivatePage =()=> {
        let { Id } = useParams();
// console.log("check", id)

    var r  =        window.location.hash
  const navigate = useNavigate();


    function ActiveStatus(){

// console.log("ID", Id)
   
        const body ={
         id:Id

       }
      
        // console.log(body)
        // let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
        // let id = 'Id ' + JSON.parse(localStorage.getItem('Id'));

         axios({
        
         method:"POST",
        url:`${BASE_URL}/User/Active`,
        data:body, 
        headers: {
        "Content-Type" : "application/json",
        }
       
         })
      
             navigate("/AccountActivation") 
         }   

  return (
    <div>
        
<div className="activation__wrapper">
  <div className="activation__container">
    <div className="activation__header"><img className="activation__logo" src="https://media.curio.ca/filer_public_thumbnails/filer_public/fe/f5/fef53e7a-a469-4359-a655-71ed9e0f318a/venture_gradient.jpg__452x254_q85_crop_subject_location-249%2C134_subsampling-2.jpg" /></div>
    <div className="activation__subject">User Activation Link</div>
    <div className="activation__arrow" />
    <div className="activation__message">
      <div>  <span className="activation__user">Welcome...!</span>
        {/*<Username>*/}
        <br />Thank you for Register in Venture Portal.</div>
    </div>
    <div className="activation__link">
      <div>
        Click on the Button to activate your account:
      </div>
      <div  className="activation__btn" onClick={()=>ActiveStatus()}>Activate your account </div>
    </div>
    <div className="activation__footer">
      Thank you. Sincerely,
      <br /> Venture Portal Team
      <br />
    </div>
  </div>
</div>

    </div>
  )
}

export default AcivatePage